var cov_1zb6r22ng4 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Input/styles/index.js",
      hash = "e672b593e4ef9cc92cd065d0761dc83fb1ad8748",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Input/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 26
        },
        end: {
          line: 5,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var inputLess = {};
import genaration from '../../utils/classname';
export var inputClass = (cov_1zb6r22ng4.s[0]++, genaration(inputLess, 'input'));